module.exports = __webpack_public_path__ + "img/jaguar-logo.28dfa98f.png";